import { map } from 'lodash-es';
import JSON5 from 'json5';
export const useTableStore = defineStore('tableStore', {
  state: () => ({
    TableField: useLocalStorage<any>('TableField', {}, { serializer: { read: JSON5.parse, write: JSON5.stringify } }),
  }),
  getters: {
    getLabels: (state) => {
      return (key: string) => {
        return map(state.TableField[key], 'label');
      };
    },
  },
  actions: {
    resetTableField() {
      this.TableField = {};
    },
  },
});
